<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">月次運賃ハンド対応一覧</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_FU_ARAP_MANUAL_SEARCH>検索</v-btn>
        <v-btn @click="$router.push('B2001')" v-permit.SHARP_FU_ARAP_MANUAL_ARNEW>AR新規</v-btn>
        <v-btn @click="$router.push('B2002')" v-permit.SHARP_FU_ARAP_MANUAL_APNEW>AP新規</v-btn>
        <v-btn :disabled="selected.length !== 1" @click="edit" v-permit.SHARP_FU_ARAP_MANUAL_EDIT>編集</v-btn>
        <v-btn
          :disabled="selected.length !== 1|| selected.filter(i => i.status === '承認待').length!==1 "
          @click="remove"
          v-permit.SHARP_FU_ARAP_MANUAL_EDIT
        >削除</v-btn>
      </v-card-actions>

      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md2 sm6 xs12>
              <remote-autocomplete
                label="サプライヤー"
                url="companies/kvt?type=SUPPLIER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <remote-autocomplete label="事業本部" url="divisions/kv?type=BU" v-model="query.buId"></remote-autocomplete>
            </v-flex>
            <v-flex md2 sm6 xs12>
              <date-picker label="年月" type="month" v-model="query.archiveYearMonth"></date-picker>
            </v-flex>
            <v-flex md1 sm4 xs12>
              <v-checkbox label="承認待" v-model="query.waitStatus"></v-checkbox>
            </v-flex>
            <v-flex md1 sm4 xs12>
              <v-checkbox label="承認済" v-model="query.finishedStatus"></v-checkbox>
            </v-flex>
            <v-flex md1 sm4 xs12>
              <v-checkbox label="AR" v-model="query.isAr"></v-checkbox>
            </v-flex>
            <v-flex md1 sm4 xs12>
              <v-checkbox label="AP" v-model="query.isAp"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :expand="expand"
        :headers="headers"
        :items="results"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td>
              <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
            </td>
            <td>{{ props.item.docNo }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.archiveYearMonth }}</td>
            <td>{{ props.item.documentType }}</td>
            <td>{{ props.item.headerText }}</td>
            <td>{{ props.item.currencyCode }}</td>
            <td>{{ props.item.taxed }}</td>
            <td>{{ props.item.unTaxed }}</td>
            <td>{{ props.item.tax }}</td>
            <td>{{ props.item.amount }}</td>
          </tr>
        </template>
        <!-- <template slot="expand" slot-scope="props">
          <v-card flat>
            <v-data-table :items="props.item.details" class="tie" hide-actions>
              <template slot="items" slot-scope="props">
                <td></td>
                <td>{{ props.item.docNo }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.yearMonth }}</td>
                <td>{{ props.item.documentType }}</td>
                <td>{{ props.item.headerText }}</td>
                <td>{{ props.item.currencyCode }}</td>
                <td>{{ props.item.postingKey }}</td>
                <td>{{ props.item.accountNumber }}</td>
                <td>{{ props.item.generalLedgerAccount }}</td>
                <td>{{ props.item.taxCode }}</td>
                <td>{{ props.item.amount }}</td>
              </template>
            </v-data-table>
          </v-card>
        </template>-->
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      expand: false,
      selected: [],
      headers: [
        { text: '', sortable: false },
        {
          text: 'Doc.no',
          sortable: false,
          value: 'docNo'
        },
        { text: '区分', sortable: false },
        { text: '承認ステータス', sortable: false },
        { text: '凍結年月', value: 'yearMonth', sortable: false },
        { text: 'Document Type', value: 'documentType', sortable: false },
        { text: 'Header Text', value: 'headerText', sortable: false },
        { text: 'Currency', value: 'currency', sortable: false },
        { text: '課金', value: 'taxed', sortable: false },
        { text: '非課税', value: 'unTaxed', sortable: false },
        {
          text: '税金',
          value: 'tax',
          sortable: false
        },
        { text: 'Amount', value: '税込', sortable: false }
      ],
      results: [],
      pagination: {
        page: 1
      }
    }
  },
  methods: {
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.$http
            .delete(`/arap/finance/manual-finance/${this.selected[0].id}`)
            .then(res => {
              if (res.data) {
                this.$message('', '削除成功')
                this.selected = []
                this.load()
              }
            })
        }
      )
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    load() {
      this.$http
        .get('/arap/finance/manual-finance', {
          params: { ...this.query, ...this.$pageable() }
        })
        .then(res => {
          this.results = res.data.content
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          console.log(res)
        })
      this.$storeParams()
    },
    edit() {
      if (this.selected[0].type === 'AR') {
        this.$router.push({
          path: '/B2001',
          query: {
            id: this.selected[0].id
          }
        })
      } else {
        this.$router.push({
          path: '/B2002',
          query: {
            id: this.selected[0].id
          }
        })
      }
    }
  },
  watch: {
    pagination() {
      this.load()
    }
  },
  mounted() {
    this.$loadParams()
  }
}
</script>
<style scoped>
</style>
